import * as fUtils from "./gnr-fileUtils.js";
import { loadComponent } from "./gnr-loader";

export class GnrHTMLElement extends HTMLElement{
    linkHTMLBody(component_html){
        // Contained in a div to avoid any kind of conflict.
        const htmlContainer = document.createElement('div');
        htmlContainer.innerHTML = component_html;
        this.shadowRoot.appendChild(htmlContainer);
    }

    linkJSScript(component_script){
        const script = document.createElement('script');
        script.textContent = component_script;
        this.shadowRoot.appendChild(script);
    }

    linkSCSSSheet(component_scss){
        const style = document.createElement('style');
        style.textContent = component_scss;
        this.shadowRoot.appendChild(style);
    }

    linkAllComponentFiles(component_html, component_script, component_scss){
        this.linkHTMLBody(component_html);// Linking HTML first to avoid erasing css/js by updating the innerHtml property.
        this.linkSCSSSheet(component_scss);
        this.linkJSScript(component_script);
    }
 
    linkElement(element){
        function linkImage(component, imgElem){
            if(component.hasAttribute("src")){
                imgElem.src = `${component.getAttribute("src")}`;
                if(!component.hasAttribute("alt")){console.warn("No alt attribute specified.") ; return;}
                imgElem.alt = component.getAttribute("alt");
            } else {
                console.warn("src attribute not specified. No image loaded.");
            }

        }
        function linkGenericElement(component, elem){
            if(component.hasAttribute(elem.id)){
                    elem.innerHTML = component.getAttribute(elem.id);
            } else{
                console.warn(`${elem.id} attribute not specified in the current document for the ${component.tagNameLowerCase} Component : its content will remain empty.`);
            }
        }

        switch(element.constructor.name){
            case "HTMLImageElement":
                linkImage(this, element);
                break;
            default:
                linkGenericElement(this, element);
        }
    }

    /**
     * Gets attributes from the html tag in the document, and sets their values to
     * the corresponding HTML content/src attribute inside the Component.
     * 
     * **!! Only works once the DOM is loaded and the html document has been fully loaded !!**
     */
    linkAllElementsWithId(){
        let elements = this.shadowRoot.querySelectorAll("[id], img");

        if(elements.length < 1){
            console.info(`${this.tagName} has no element with whose content can be set. Attributes may be useless.`);
        }

        // still running the loop : images do not necessarily have an id but still 
        for(let i = 0; i<  elements.length; i++){
            this.linkElement(elements.item(i));
        }
    }

    getAssetPath(assetName){
        for(const type in this.assetPaths){
            if(this.assetPaths[type][assetName]) return this.assetPaths[type][assetName]
        }
    }

    disconnectedCallback() {{
        console.log('Custom element ' + this.tagNameLowerCase + ' removed from the DOM');
    }}

    constructor() {{
        super();
    
        // Getting attributes
        this.tagNameLowerCase = this.tagName.toLowerCase();

        // DOM content loading flags/events
        this.readyState = 'loading';
    }}
}